import React, { useState } from "react";

import { Layout, Menu, ConfigProvider, theme, Typography, Button } from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  BellOutlined,
  UploadOutlined,
  QuestionOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons";
import "./layout.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { accessToken, refreshToken, userData } from "../redux/userDataSlice";
import { callApi } from "../api/apiCaller";
import { routes } from "../api/routes";
import Loader from "../components/loader/loader";
import { GreenNotify, RedNotify } from "../helper/helper";
import Dashboard from "../pages/dashboard/dashboard";
import Home from "../pages/home/home";
import Users from "../pages/userlist/Users";
import SendNotification from "../pages/senNotification/sendNotification";
import UserListWithUpload from "../pages/uploadFile/uploadFile";
import Faqs from "../pages/Faqs/faqs";
import EditFaq from "../pages/editFaq/editFaq";

const { Header, Sider, Content } = Layout;
const { Title } = Typography;
const LayoutDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = () => {
    // let getRes = (res) => {
    //   if (res.status === 200) {
    GreenNotify("Logout successfully");
    dispatch(userData(null));
    dispatch(accessToken(""));
    dispatch(refreshToken(""));
    //   } else {
    //     RedNotify(res.message);
    //   }
    // };

    // let body = {
    //   device: {
    //     id: localStorage.getItem("deviceId"),
    //     deviceToken: "xyz",
    //   },
    // };

    // callApi("POST", routes.logOut, body, setIsLoading, getRes, (error) => {
    //   console.log("error", error);
    // });
  };
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#E73334", // Setting your primary color globally
          fontFamily: "Roboto, sans-serif",
        },
      }}
    >
      <Layout style={{ minHeight: "100vh", position: "relative" }}>
        <Loader loading={isloading} />
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          collapsedWidth={80}
          // Requested 30% width
          className="admin-sider"
          theme="light"
          breakpoint="lg" // Optional: responsive behavior
        >
          {/* Logo / Title */}

          <div style={{ height: 32, margin: 16, textAlign: "center" }}>
            {/* You can put your logo here */}
            <span
              style={{ color: "#e73334", fontSize: 18, fontWeight: "bold" }}
            >
              {collapsed ? "E" : "Erchonia Admin"}
            </span>
          </div>
          <Menu
            theme="light"
            mode="inline"
            defaultSelectedKeys={["1"]}
            items={[
              {
                key: "1",
                icon: <UserOutlined />,
                label: "Admin User",
                onClick: () => navigate("/"),
              },

              {
                key: "3",
                icon: <UploadOutlined />,
                label: "Upload",
                onClick: () => navigate("/upload-file"),
              },
              {
                key: "2",
                icon: <BellOutlined />,
                label: "Send Notification",
                onClick: () => navigate("/send-notification"),
              },
              {
                key: "5",
                icon: <QuestionOutlined />,
                label: "FAQ's",
                onClick: () => navigate("/faqs"),
              },
              {
                key: "4",
                icon: <LogoutOutlined />,
                label: "Logout",
                onClick: logOut,
              },
            ]}
          />
        </Sider>

        {/* MAIN LAYOUT */}
        <Layout>
          <Header className="app-header">
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* Custom Trigger to toggle sidebar */}
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: "16px",
                  width: 64,
                  height: 64,
                  marginRight: 16, // Space between button and title
                }}
              />
              {/* Name of the Tree */}
              <span className="erchonia-text">Erchonia Super Admin</span>
            </div>
          </Header>
          {/* Header */}
          {/* <Header
          style={{
            background: "#fff",
            padding: "0 20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Title
            level={5}
            style={{
              margin: 0,
              color: "#5563DE",
              fontWeight: 600,
            }}
          >
            Dashboard
          </Title>
        </Header> */}

          {/* Content */}
          <Content className="app-content">
            <Routes>
              <Route path="/" element={<Users />}></Route>
              <Route path="/home" element={<Home />}></Route>
              <Route path="/users" element={<Users />}></Route>
              <Route
                path="/upload-file"
                element={<UserListWithUpload />}
              ></Route>
              <Route path="/faqs" element={<Faqs />}></Route>
              <Route path="/edit-faqs" element={<EditFaq />}></Route>
              <Route
                path="/send-notification"
                element={<SendNotification />}
              ></Route>
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default LayoutDashboard;
